<template>
  <!-- ======= Contact Section ======= -->
  <section id="contact" class="services section-bg">
    <div class="container">
      <div class="section-title">
        <h2>Contact me</h2>
      </div>
      <div class="row">
        <div class="col">
          <p class="contact-describe">聯絡電話</p>
        </div>
        <div class="col">
          <p class="contact-describe">(04)2392-4505 分機:8777</p>
        </div>
        <div class="p-2 w-100"></div>
        <div class="col">
          <p class="contact-describe">信箱</p>
        </div>
        <div class="col">
          <p class="contact-describe">duke.ncut@gmail.com</p>
        </div>
      </div>
    </div>
  </section>
  <!-- End Services Section -->
</template>

<script>
export default {
  name: "contact",
};
</script>

<style lang="scss">
/*--------------------------------------------------------------
# contact
--------------------------------------------------------------*/
.contact .title {
  font-weight: 700;
  margin-bottom: 15px;
  font-size: 25px;
  text-transform: uppercase;
}
.contact .title a {
  color: #343a40;
  transition: 0.3s;
}
.contact .icon-box:hover .title a {
  color: #70b9b0;
}

/*--------------------------------------------------------------
# Contact us
--------------------------------------------------------------*/
.contact-describe {
  font-size: 2vh;
  font-family: "NotoSansTC_Bold";
}
</style>
